import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';
import { Spin, Menu } from 'antd';
import Icon from '@ant-design/icons';

import { getAllNotifications } from 'services/notifications';
import { sendSegment } from 'utils/segment';
import {
  LOAD_MORE_INITIAL_ITEMS,
  LOAD_MORE_MAX_ITEMS
} from 'constants/notifications';

import SingleNotification from 'components/Notifications/components/SingleNotification/SingleNotification';
import { notify } from 'components/Notify/Notify';
import { ReactComponent as Notification } from 'assets/bosta-icons/Notification.svg';

import './Notifications.less';

const Notifications = ({ intl }) => {
  const [totalPage, setTotalPage] = useState(0);
  const [totalNotifications, setTotalNotifications] = useState(0);
  const [loading, setLoading] = useState(false);
  const [allNotifications, setAllNotifications] = useState([]);

  useEffect(() => {
    setLoading(true);
    sendSegment('E_NOTIFICATION_READ');
    setAllNotifications([]);
    getAllNotification(LOAD_MORE_INITIAL_ITEMS);
  }, []);

  const getAllNotification = async (pageLimit) => {
    try {
      setLoading(true);
      const response = await getAllNotifications({
        page: 1,
        limit: pageLimit + totalPage
      });
      const { total, list } = response;
      setTotalPage(pageLimit + totalPage);
      setTotalNotifications(total);
      setAllNotifications(list);
      setLoading(false);
    } catch (error) {
      notify({ msg: error.message, error });
      setLoading(false);
    }
  };

  return (
    <Menu>
      <div className="br-notification__container font-family__default">
        <div className="br-notification__title heading border-bottom">
          {intl.formatMessage({
            id: 'notification.title'
          })}
        </div>
        {!allNotifications.length && !loading ? (
          <div className="br-notification__no-content-container">
            <div className="br-notification__no-content-img">
              <Icon component={Notification} />
            </div>

            <div className="br-notification__no-content-text body">
              {intl.formatMessage({
                id: `notification.empty_notification_status`
              })}
            </div>
          </div>
        ) : (
          <div className="br-notification__items-container">
            {loading && (
              <div className="br-notification__loading">
                <Spin />
              </div>
            )}
            {allNotifications.map((item) => (
              <Menu.Item key={item._id} className="br-notification__item">
                <SingleNotification item={item} />
              </Menu.Item>
            ))}
          </div>
        )}
        <div
          className="br-notification__load-more button"
          hidden={totalPage > totalNotifications || !allNotifications.length}
          onClick={
            !loading
              ? () => {
                  sendSegment('E_NOTIFICATIONS_LOAD_MORE');
                  getAllNotification(LOAD_MORE_MAX_ITEMS);
                }
              : null
          }
        >
          {intl.formatMessage({
            id: 'notification.load_more'
          })}
        </div>
      </div>
    </Menu>
  );
};
export default injectIntl(withRouter(Notifications));
